import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import useDashboardSelection from "../../hooks/UseDashboardSelection";
import WeekDateSelect from "../DateSelection/WeekDateSelection/WeekDateSelect";
import BuildingSelect from '../BuildingSelection/BuildingSelect';
import Spinner from '../Spinner/Spinner';
import { Stack } from '@mui/material';
import UseTimesheet from './UseTimesheet';
import { startOfWeek } from 'date-fns';
import { endOfWeek } from 'date-fns/esm';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));


const Timesheet = () => {
    const {start, setStart, end, setEnd,buildingId,setBuildingId,buildings,buildingSelections,isLoading} = useDashboardSelection(startOfWeek(new Date()),endOfWeek(new Date()));
    const {dates, users, userScans, userTotals, keyEncoder} = UseTimesheet({start,end, buildings});
    const formatScan = (scan : number) => (scan/60) < 0.01 ? 0 : (scan/60).toFixed(2);

    return (
        <>
            <header style={{paddingBottom : 5}}>
                <Stack direction={'row'} spacing={2}>
                    <WeekDateSelect start={start as Date} setStart={setStart} setEnd={setEnd} labelName="week"></WeekDateSelect>
                    <BuildingSelect buildingId={buildingId} setBuildingId ={setBuildingId} buildingSelections={buildingSelections}></BuildingSelect>
                </Stack>
            </header>
            {
            isLoading ? <Spinner/> :
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 700 }} aria-label="timesheet table">
                    <TableHead>
                    <TableRow>
                        <StyledTableCell>Username</StyledTableCell>
                        {dates.map(date =><StyledTableCell>{date.format("dddd, Do")}</StyledTableCell>)}
                        <StyledTableCell align="right">Total (h)</StyledTableCell>
                    </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            Array.from(users).map(username => 
                                <StyledTableRow key={username}>
                                         <StyledTableCell component="th" scope="row">{username}</StyledTableCell>
                                         {dates.map(date =>  <StyledTableCell align="center">{formatScan(userScans.get(keyEncoder(username,date)) || 0)}</StyledTableCell>)}
                                         <StyledTableCell align="right">{formatScan(userTotals.get(username) || 0)}</StyledTableCell>
                                </StyledTableRow>
                            )
                        }
                    </TableBody>
                </Table>
            </TableContainer>
            }
        </>
      );
}

export default Timesheet;
